import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {AFFILIATE_POINT_CONVERTING_URL} from '@web/core/urls'
import {unsubscribeMessage, subscribeMessage, changeBrowserLocation, openPopup} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {NavigationResult, NavigationTypeSelectableParam, ReturnUrlComposerParam, ThunkApi} from '../interfaces'

const POPUP_KEY = 'CONVERT_AFFILIATE_POINT'
const MESSAGE_KEY = 'reloadParentWindow'

/**
 * 제휴 포인트 조회 및 전환 페이지로 이동
 */
const navigateToAffiliatePointConverting = createAsyncThunk<
    NavigationResult,
    (NavigationTypeSelectableParam & ReturnUrlComposerParam) | void,
    ThunkApi
>('navigateTo/affiliatePointConverting', async (args) => {
    const {forceLocationChange = false} = args ?? {}
    const shouldChangeLocation = forceLocationChange || isMobile

    if (shouldChangeLocation) {
        const url = qs.stringifyUrl({
            url: AFFILIATE_POINT_CONVERTING_URL,
            query: {
                rUrl: window.location.href,
            },
        })

        changeBrowserLocation({url, type: 'PUSH'})
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    }

    const popupUrl = qs.stringifyUrl({
        url: AFFILIATE_POINT_CONVERTING_URL,
        query: {
            backType: 'CLOSE',
        },
    })

    return new Promise<string | void>((resolve, reject) => {
        const resolveCallback = () => resolve('success')

        // popup으로부터 유효한 메시지 받았을 때만 result로  메시지 전달
        subscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})

        // popup만 오픈
        openPopup({
            key: POPUP_KEY,
            url: popupUrl,
            popupQuery: {
                callback: MESSAGE_KEY,
            },
            size: {
                width: 500,
                height: 640,
            },
        })
            .then(() => resolve())
            .catch(reject)
            .finally(() => {
                // popup open 실패했든 종료했든 popup open시도가 끝났다면 message subscription 종료
                unsubscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})
            })
    })
})

export default navigateToAffiliatePointConverting
